import { render, staticRenderFns } from "./ImportExportLayout.vue?vue&type=template&id=12cc3669&scoped=true&"
import script from "./ImportExportLayout.vue?vue&type=script&lang=js&"
export * from "./ImportExportLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cc3669",
  null
  
)

export default component.exports